
import axiosServices from './axios';

export const getGroupAnalytics = async ( groupName, since, until) => {
    try {
        const response = await axiosServices.post(
            `${process.env.REACT_APP_BACKEND_API}/group/group-analytics`,
            {
                groupName,
                selectedProfiles: [],
                since: since.toISOString().split('T')[0],
                until: until.toISOString().split('T')[0],
            },
         
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching group analytics:', error);
        throw error;
    }
};

export const processFBData = (FBImpression) => {
    let FBImpressions = [];
    if (FBImpression.length > 1) {
        FBImpressions = FBImpression[0].concat(FBImpression[1]);
    }
    return FBImpressions.reduce((acc, item) => acc + item.value, 0);
};

export const processChartData = (rawData) => {
    const reduced = rawData.reduce((acc, { end_time, value }) => {
        const dateKey = end_time.split("T")[0];
        acc[dateKey] = (acc[dateKey] || 0) + Number(value || 0);
        return acc;
    }, {});

    return Object.entries(reduced).map(([date, val]) => ({
        x: date.split("-")[1] + '-' + date.split("-")[2],
        y: val
    }));
};

export const sumChartData = (data) => {
    return data.reduce((sum, item) => sum + Number(item.value || 0), 0);
};
export const getPercentageChangeText = (current = 0, previous = 0) => {
    if (previous === 0 && current === 0) return "No change";
    if (previous === 0) return "Increased by 100%";
    
    const change = (((current - previous) / previous) * 100).toFixed(2);

    if (change > 0) return `Increased by ${change}%`;
    if (change < 0) return `Decreased by ${Math.abs(change)}%`;
    return "No change";
};

export const getArrowDirection = (change) => {
  if (change > 0) {
    return { icon: "fa-arrow-up", color: "#21A500" }; // Green Up
  } else if (change < 0) {
    return { icon: "fa-arrow-down", color: "#FF0000" }; // Red Down
  } else {
    return { icon: "fa-arrow-right", color: "#000000" }; // Black Side
  }
};
